export default __webpack_public_path__ + "images/89a71376d6d497a59ab97ddfbe7a0a49.png";